<template>
  <div class="wlx-stu-manager-wrapper">
    <el-tabs tab-position="top" style="height: auto" v-model="tabName" @tab-click="handleClick">
      <el-tab-pane label="学习资料" name="first">
        <LearningMaterials v-if="tabName=='first'"></LearningMaterials>
      </el-tab-pane>
      <el-tab-pane label="站点考核信息审核" name="second">
        <StuTestAudit v-if="tabName=='second'"></StuTestAudit>
      </el-tab-pane>
      <el-tab-pane label="站点培训信息审核" name="third">
        <StuTrainAudit v-if="tabName=='third'"></StuTrainAudit>
      </el-tab-pane>
      <el-tab-pane label="学员考证审核" name="fourth">
        <SudentAudit v-if="tabName=='fourth'"></SudentAudit>
      </el-tab-pane>
      <el-tab-pane label="申请标准" name="fifth">
        <certifyStadard v-if="tabName=='fifth'" type="1"></certifyStadard>
      </el-tab-pane>
      <el-tab-pane label="认证节点" name="sixth">
        <AuthenticationNode v-if="tabName=='sixth'" type="1"></AuthenticationNode>
      </el-tab-pane>
      <el-tab-pane label="章节素材管理" name="seven">
        <ChapterMaterialManage v-if="tabName=='seven'"></ChapterMaterialManage>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { MU_UPATE_AUTH } from "store/index";
import StudentAttestation from "page/xSchool/manager/StudentAttestation.vue";
import LearningMaterials from "page/xSchool/manager/LearningMaterials.vue";
import StuTestAudit from "page/xSchool/manager/StuTestAudit.vue";
import StuTrainAudit from "page/xSchool/manager/StuTrainAudit.vue";
import SudentAudit from "page/xSchool/manager/SudentAudit.vue";
import certifyStadard from "page/xSchool/manager/siteCertifyStadard.vue";
import AuthenticationNode from "page/xSchool/manager/siteAuthenticationNode.vue";
import ChapterMaterialManage from "page/xSchool/manager/ChapterMaterialManage.vue";
export default {
  data() {
    return {
      tabName: "first"
    };
  },
  components: {
    StudentAttestation,
    LearningMaterials,
    StuTestAudit,
    StuTrainAudit,
    SudentAudit,
    certifyStadard,
    AuthenticationNode,
    ChapterMaterialManage
  },
  created() {
    
    // var that = this;
    // if (localStorage["userId"] !== undefined) {
    //   that.$store.dispatch(MU_UPATE_AUTH).then(rt => {});
    // }
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    }
  },
  computed: {}
};
</script>
<style lang="scss">
.wlx-stu-manager-wrapper{
  .el-tabs__header {
        position: fixed;
        top: 60px;
        right: 0;
        height: 60px;
        width: calc(100% - 240px);
        z-index: 1000;
        background: #fff;
        text-align: right;
    }
    .el-tabs__item {
        padding: 0 30px;
        text-align: center;
        height: 60px;
        line-height: 60px;
        font-size: 16px;
    }
    .el-tabs--top .el-tabs__item.is-top:nth-child(2){
       padding-left: 20px;
    }
    .el-tabs__content {
        margin: 80px 0 0 30px;
        background: #fff;
        .el-tab-pane {
            padding: 20px;
        }
    }
}
</style>
